/** Old home of the RSW reports: they live under Reports > RSW since 2026-10-15. */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/warehouse/$stage/reports/")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/warehouse", replace: true });
  },
});
